import { SQCookie } from '../../utils/legacyV2Cookies';
import { NAV_CUSTOM_EVENTS } from '../constants';
import { getLocalizedUrl } from './url';

export const PULSE_INSIGHTS_SRC = `https://${process.env.HOST_NAME}/assets/vendor/pulse-insights/2024.9.25/surveys.js`;
export const PULSE_INSIGHTS_ID = 'PI-42807056';

/**
 * Pulse insights site feedback trigger
 * @param {object} args
 * @param {import('./hooks/localeHook').Locale} args.locale
 */
export function pulseInsightsTrigger({ locale }) {
  const { country, language, langRegion } = locale;
  const { allowPerformance } = SQCookie.get();

  /* eslint-disable */
  /* istanbul ignore else */
  if (!window.pi) {
    window.pi = function() {
      window.pi.commands = window.pi.commands || [];
      window.pi.commands.push(arguments);
    };

    const script = document.createElement('script');
    script.id = 'pulse-insights';
    script.src = PULSE_INSIGHTS_SRC;
    script.async = true;

    const pulseInsightsScript = document.getElementsByTagName('script')[0];
    pulseInsightsScript.parentNode.insertBefore(script, pulseInsightsScript);
  }

  pi('identify', PULSE_INSIGHTS_ID);
  pi('spa', false);
  pi('set_context_data', { country, language });

  // If a user does not allow performance cookies, we do not track them or their response
  if (allowPerformance) pi('visitor_tracking', true);

  if (!langRegion) {
    pi('get', 'surveys');
  } else {
    const surveyId = `feedback-link-${country.toLowerCase()}-${langRegion}`;
    pi('present', surveyId);
  }
  /* eslint-enable */
}

/**
 * Triggers the cookie modal or redirects to localized guest settings privacy page.
 *
 * @param {Object} args - The args for the cookie modal trigger.
 * @param {import('./hooks/localeHook').Locale} args.locale - The locale for the localized URL.
 */
const cookieModalTrigger = ({ locale }) => {
  if (!window.NikePrivacy?.isEnabled)
    return window.dispatchEvent(new Event(NAV_CUSTOM_EVENTS.OPEN_COOKIE_MODAL));

  const localizedUrl = getLocalizedUrl('guest/settings/privacy');
  const guestSettingsPage = localizedUrl(locale);
  window.location.assign(guestSettingsPage);
};

/**
 * Qualtrics Website Feedback trigger
 */
export function qualtricsFeedbackTrigger() {
  const QUALTRICS_SRC = `https://${process.env.HOST_NAME}/assets/vendor/qualtrics/2.37.0/qualtrics.js`;
  const QUALTRICS_DIV_ID = 'ZN_V2UidZcFO3RC5nH';

  if (!document.getElementById(QUALTRICS_DIV_ID)) {
    const div = document.createElement('div');
    div.id = QUALTRICS_DIV_ID;
    // Optionally: div.innerHTML = '<!--DO NOT REMOVE-CONTENTS PLACED HERE-->';
    document.body.appendChild(div);
  }

  if (!window.qualtricsLoaded) {
    window.qualtricsLoaded = true;
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = QUALTRICS_SRC;
    script.async = true;

    const firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode.insertBefore(script, firstScript);
  }
}

export const triggers = {
  '#site-feedback': qualtricsFeedbackTrigger,
  '#cookie_settings': cookieModalTrigger,
  '#cookie_settings.html': cookieModalTrigger,
  '/cookie_settings.html': cookieModalTrigger,
};
